import { ERROR_PLUGIN_SET } from "./PluginErrorAction";

/**
 *
 * @param {*} state
 * @param {*} action
 * Reducer for not sended query plugins
 *
 */
export default function PluginErrorReducer(
    state = {
        errorPluginMap: new Map(),
    },
    action
) {
    switch (action.type) {
        case ERROR_PLUGIN_SET:
            return {
                ...state,
                errorPluginMap: action.payload
            };
        default:
            return state;
    }
}
